import React, { useState } from "react";
import { Checkbox, FormControlLabel } from "@mui/material";
import CustomModal from "../common/CustomModal";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { ModerationIssuePicker } from "./ModerationIssues";

export default function DecisionConfirmModal({
  action, // "approved" | "rejected"
  isLoading,
  canEnterErrors,
  errorsValue,
  onErrorsChange,
  issuesValue = [],
  onIssuesChange,
  onClose,
  onConfirm,
}) {
  const isApprove = action === "approved";
  const [isConfirmed, setIsConfirmed] = useState(false);
  const needsIssues = !isApprove && typeof onIssuesChange === "function";
  const hasIssues = issuesValue.length > 0;
  const confirmUnlocked = isApprove ? isConfirmed : !needsIssues || hasIssues;

  return (
    <CustomModal
      open
      className="lg:!w-[40%]"
      title={
        <span className={`${isApprove ? "text-emerald-700" : "text-rose-700"}`}>
          {isApprove ? "Approve this ad?" : "Reject this ad?"}
        </span>
      }
      onClose={isLoading ? undefined : onClose}
      isButtonsRequired={false}
      handleConfirmation={confirmUnlocked && !isLoading ? onConfirm : undefined}
    >
      <div className="space-y-4 py-2">
        <p className={`font-semibold py-2 text-[16px]`}>
          {isApprove
            ? "Are you sure you want to Approve? Once Approved, the decision cannot be undone."
            : "Are you sure you want to Reject? Once Rejected, the decision cannot be undone, and the delivery team will need to resubmit a new iteration."}
        </p>
        {needsIssues && (
          <div>
            <Label className="block text-xs font-medium text-gray-500 mb-2">
              Issues <span className="text-rose-600">*</span>
            </Label>
            <ModerationIssuePicker
              value={issuesValue}
              onChange={onIssuesChange}
              disabled={isLoading}
            />
            {!hasIssues && (
              <p className="mt-1.5 text-xs text-rose-600">
                Select at least one issue to reject this ad.
              </p>
            )}
          </div>
        )}
        {!isApprove && canEnterErrors && (
          <div>
            <Label className="block text-xs font-medium text-gray-500 mb-2">
              Errors
            </Label>
            <textarea
              value={errorsValue}
              onChange={(e) => onErrorsChange(e.target.value)}
              placeholder="One per line"
              rows={5}
              className="w-full rounded-md border border-input px-3 py-2 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-ring read-only:bg-muted/40"
            />
          </div>
        )}
        {isApprove && (
          <FormControlLabel
            control={
              <Checkbox
                autoFocus
                size="small"
                checked={isConfirmed}
                onChange={(e) => setIsConfirmed(e.target.checked)}
                sx={{ "&.Mui-checked": { color: "#059669" } }}
              />
            }
            label={
              <span className="text-sm text-gray-700">
                I've checked this ad and want to approve it
              </span>
            }
          />
        )}
        <div className="flex justify-end gap-2 pt-2">
          <Button
            size="sm"
            variant="outline"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            size="sm"
            onClick={onConfirm}
            disabled={!confirmUnlocked || isLoading}
            className={
              isApprove
                ? "bg-emerald-600 hover:bg-emerald-700 text-white"
                : "bg-rose-600 hover:bg-rose-700 text-white"
            }
          >
            {isLoading
              ? isApprove
                ? "Approving…"
                : "Rejecting…"
              : isApprove
                ? "Approve"
                : "Reject"}
          </Button>
        </div>
      </div>
    </CustomModal>
  );
}
